import { ComponentType } from '@angular/cdk/overlay'
import { Injectable } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material'
import { AtylDialogConfig } from '../../Interfaces/AtylDialogConfig'
import { MinimizeTab } from '../../Interfaces/MinimizeTab'
import { StateService } from './state.service'

const BACKDROP_CSS_CLASS = 'cdk-overlay-dark-backdrop',
	BACKDROP_CSS_CLASS_OPEN = ['cdk-overlay-backdrop', 'cdk-overlay-dark-backdrop', 'cdk-overlay-backdrop-showing']

@Injectable({
	providedIn: 'root',
})
export class DialogService {

	private config: AtylDialogConfig
	private dialogRef: MatDialogRef<any>
	private defaultConfig: AtylDialogConfig = {
		maxHeight: '100vh',
		maxWidth: '100vw',
		draggable: false,
		resizable: true,
		minimizable: false,
		maximizable: false,
		disableClose: true,
		panelClass: ['animate__animated', 'animate__slideInDown'],
		hasBackdrop: true,
		backdropClass: BACKDROP_CSS_CLASS //cdk-overlay-backdrop
	};
	private backdropElement: HTMLElement
	constructor(private dialog: MatDialog, private stateService: StateService) {

	}

	open<T>(component: ComponentType<T>, config?: AtylDialogConfig, afterClosed?: Function) {

		config = { ...this.defaultConfig, ...config }

		this.config = config

		const dialogRef = this.dialog.open(component, config)

		this.backdropElement = document.querySelector(`.${BACKDROP_CSS_CLASS}`)
		BACKDROP_CSS_CLASS_OPEN.forEach(className => {
			this.backdropElement.classList.add(className)
		})
		dialogRef.afterClosed().subscribe((result) => {
			if (afterClosed) {
				afterClosed(result)
			}
		})

		this.dialogRef = dialogRef
		return this.dialogRef;
	}

	closeAll() {
		this.dialog.closeAll()
	}
	close(afterCloseData?: any) {
		this.dialogRef.close(afterCloseData)
	}

	configurate() {
		return this.config
	}
	ref() {
		return this.dialogRef
	}

	addMinimizeTab(tab: MinimizeTab) {
		tab.backdropElement.className = ''
		this.stateService.addMinimizeTab(tab)
	}

	removeMinimizeTab(tab: MinimizeTab) {
		this.stateService.removeMinimizeTab(tab)
	}

}
